import { Observable } from "rxjs";
/**
 * @class API
 *
 * @classdesc Provides methods for access to the API.
 */
export class APIWrapper {
    constructor(_data) {
        this._data = _data;
    }
    get data() {
        return this._data;
    }
    imageByKeyFill$(keys) {
        return this._wrapPromise$(this._data.getFillImages(keys));
    }
    imageByKeyFull$(keys) {
        return this._wrapPromise$(this._data.getFullImages(keys));
    }
    imagesByH$(h) {
        return this._wrapPromise$(this._data.getCoreImages(h));
    }
    sequenceByKey$(sequenceKeys) {
        return this._wrapPromise$(this._data.getSequences(sequenceKeys));
    }
    imagesByKNN$(easting, northing, epsg) {
        return this._wrapPromise$(this._data.findNearest(easting, northing, epsg));
    }
    _wrapPromise$(promise) {
        return Observable.create((subscriber) => {
            promise.then((value) => {
                subscriber.next(value);
                subscriber.complete();
            }, (error) => {
                subscriber.error(error);
            });
        });
    }
}
//# sourceMappingURL=APIWrapper.js.map